"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flexbox = exports.AlignRight = exports.AlignLeft = void 0;
var _react = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const AlignLeft = exports.AlignLeft = /*#__PURE__*/(0, _react.styled)("section")({
  name: "AlignLeft",
  class: "pl-a3y3ajh"
});
const AlignRight = exports.AlignRight = /*#__PURE__*/(0, _react.styled)("section")({
  name: "AlignRight",
  class: "pl-aqya02f"
});

/**
 * Flexbox component.
 * @module Flexbox
 * @TODO @ccarraher turn flexbox into gallery when wrap behavior is no-wrap
 *                  and number of entries exceeds max entries
 *
 * @param {Object} props React props
 * @param {boolean} props.isColumn Boolean indicating whether flex direction is column
 * @param {boolean} props.contrast Render with high contrast background
 * @param {string} props.xlEntries Number of entries shown in a row for XL breakpoint
 * @param {string} props.desktopEntries Number of entries shown in a row for Desktop breakpoint
 * @param {string} props.tabletEntries Number of entries shown in a row for Tablet breakpoint
 * @param {string} props.mobileEntries Number of entries shown in a row for Mobile breakpoint
 * @param {string} props.wrapBehavior Wrap behavior for the flexbox
 * @returns {React.ReactElement} Flexbox container
 * @public
 */
const Flexbox = exports.Flexbox = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Flexbox",
  class: "pl-f18at31n",
  vars: {
    "f18at31n-0": [({
      contrast = false
    }) => contrast ? _intents.default.ux.boxHighContrast.backgroundColor : 'transparent'],
    "f18at31n-1": [({
      isColumn = false
    }) => isColumn ? 'column' : 'row'],
    "f18at31n-2": [({
      wrapBehavior = 'wrap'
    }) => wrapBehavior],
    "f18at31n-4": [({
      mobileEntries = 1
    }) => `${100 / mobileEntries}%`],
    "f18at31n-7": [({
      tabletEntries = 1
    }) => `${100 / tabletEntries}%`],
    "f18at31n-10": [({
      desktopEntries = 1
    }) => `${100 / desktopEntries}%`],
    "f18at31n-12": [({
      xlEntries = 1
    }) => `${100 / xlEntries}%`]
  }
});
Flexbox.propTypes = {
  isColumn: _propTypes.default.bool,
  xlEntries: _propTypes.default.number,
  desktopEntries: _propTypes.default.number,
  tabletEntries: _propTypes.default.number,
  mobileEntries: _propTypes.default.number,
  wrapBehavior: _propTypes.default.string,
  contrast: _propTypes.default.bool
};